import React from 'react'

function Resume() {
    return (
        <div className='acheivment-bg'>
            <div className=''>
            <span className='flex justify-center my-8' id='myproject-title'>My<span id='myproject-title2'>Experience</span> </span>

            <div className='flex flex-col m-auto mb-4' id='acheivment-box' >
                <span id='achievement-text' className='m-auto'>Full Stack Developer</span>
                <span className='m-auto' id='subtext-ach'>V2 Cloud · Jan 2025 - Present · Remote</span>
            </div>
            
            <div className='flex flex-col m-auto mb-4' id='acheivment-box' >
                <span id='achievement-text' className='m-auto'>Junior Full Stack Developer</span>
                <span className='m-auto' id='subtext-ach'>V2 Cloud · May 2023 - Jan 2025 · Remote</span>
            </div>

            <div className='flex flex-col m-auto mb-4' id='acheivment-box' >
                <span id='achievement-text' className='m-auto'>Full Stack Developer Intern</span>
                <span className='m-auto' id='subtext-ach'>V2 Cloud · Aug 2022 - Apr 2023 · Remote</span>
            </div>

            <div className='flex flex-col m-auto mb-4' id='acheivment-box' >
                <span id='achievement-text' className='m-auto'>Technology Consultant</span>
                <span className='m-auto' id='subtext-ach'>PwC Czech Republic · Sep 2022 - Apr 2023 · Hybrid</span>
            </div>

            <div className='flex flex-col m-auto mb-4' id='acheivment-box' >
                <span id='achievement-text' className='m-auto'>Technical Assistant - Department of Computer Science</span>
                <span className='m-auto' id='subtext-ach'>Toronto Metropolitan University · May 2022 - Sep 2022 · Hybrid</span>
            </div>

            <div className='flex flex-col m-auto mb-4' id='acheivment-box' >
                <span id='achievement-text' className='m-auto'>Software Developer</span>
                <span className='m-auto' id='subtext-ach'>FEAS · Sep 2021 - May 2022 · Remote</span>
            </div>

            <div className='flex flex-col m-auto mb-4' id='acheivment-box' >
                <span id='achievement-text' className='m-auto'>Tobacco Youth Test Shopper</span>
                <span className='m-auto' id='subtext-ach'>City of Toronto · Mar 2018 - Feb 2020 · Toronto, Ontario</span>
            </div>
            
            <div className='pb-4'></div>
            </div>
        </div>
    )
}

export default Resume
